import {WinMeterEvents, WinMeterView, WinMeterViewMobile} from '@gongxigames/framework/slot/modules/winmeter/index';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';

export class WinMeterModule extends Module<WinMeterView|WinMeterViewMobile> {
    public static readonly NAME: symbol = Symbol('WinMeterModule');

    private isPlaying = false;

    protected setupEvents(): void {
        super.setupEvents();

        this.on(WinMeterEvents.COUNT_UP, this.countUp);
        this.on(WinMeterEvents.STOP_AFTER_SHOWING_FINAL_VALUE, this.stopAfterShowingFinalValue);
        this.on(WinMeterEvents.STOP_FINAL_VALUE_TIMER, this.stopFinalValueTimer);
        this.on(WinMeterEvents.SET_VALUE, this.setValue);
        this.on(WinMeterEvents.RESTORE_VALUE, this.setValue);
        this.on(WinMeterEvents.SNAP_TO_FINAL_VALUE, this.snapToFinalValue);
        this.on(WinMeterEvents.STOP, this.hideWinMeter);
    }

    protected setupStates(): void {
    }

    protected setupViews(): void {
        if (this.isPlatformDesktop()) {
            this.setView(WinMeterView.NAME);
        } else {
            this.setView(WinMeterViewMobile.NAME);
        }
    }

    protected countUp(eventName: symbol, from: number, to: number, duration: number, callback: Function): void {
        this.view.countUp(from, to, duration, () => {
            if (callback) {
                callback();
            }

            this.stop();
        });
        this.isPlaying = true;
    }

    protected stopAfterShowingFinalValue(eventName: symbol, value: number, clearMeterAfterPause: boolean): void {
        this.view.stopAfterShowingFinalValue(value, clearMeterAfterPause);
        this.stop();
    }

    protected stopFinalValueTimer(): void {
        this.view.stopFinalValueTimer();
    }

    protected setValue(eventName: symbol, value: number, setIfPlaying?: boolean): void {
        this.view.setValue(value, setIfPlaying!);
    }

    protected snapToFinalValue(): void {
        this.view.snapToFinalValue();
        this.stop();
    }

    protected hideWinMeter(): void {
        this.view.hideWinMeter();
        this.stop();
    }

    private stop(): void {
        if (this.isPlaying) {
            this.isPlaying = false;
            this.slotEventAdapter.emit('General.WinPresentation.WIN_METER_STOPPED');
        }
    }
}
